import { gql } from "@apollo/client";
import { ACFMediaFragment } from "@/fragments";
import { ExhibitFragment } from "@/fragments/Exhibit";

export const ClassExhibitQuery = gql`
  ${ACFMediaFragment}
  ${ExhibitFragment}
  query GetClassExhibit($databaseId: ID!) {
    classOfExhibit(databaseId: $databaseId) {
      ...ExhibitFragment
    }
  }
`;